module.exports = __webpack_public_path__ + "img/apple_store.b7f3010e.svg";